import { defineTracker } from '@zg-rentals/rentals-analytics';

export const tracker = defineTracker<{ event: string; [key: string]: string }>((payload, instrument) => {
  // do not expose global google types to consumers
  if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
    window.dataLayer.push(payload);
    instrument(payload.event);
  }
});
